module.exports = __webpack_public_path__ + "img/qu_qa.7c8f8c0.jpg";